export default {
  mounted () {
    let that = this
    if (typeof Connection !== 'undefined') this.online = navigator.connection.type !== Connection.NONE // eslint-disable-line no-undef
    document.addEventListener('offline', function () {
      that.online = false
    }, false)
    document.addEventListener('online', function () {
      that.online = true
    }, false)
  },
  data () {
    return {
      online: true
    }
  }
}
